{
  "close": "閉じる",
  "notifications": "通知"
}
